import styled from 'styled-components';
import { flexBox } from 'styles/mixins';

export const Background = styled.div`
  background-color: #fff;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.border.grey}`};
`;

export const QRInfoWrapper = styled.div`
  ${flexBox('row', 'center', 'center')};
  height: 76px;
  border-radius: 10px 10px 0px 0px;
  border: 1px solid rgba(17, 0, 0, 0.08);
  background: linear-gradient(
    91deg,
    rgba(107, 78, 245, 0.1) 0%,
    rgba(108, 78, 245, 0.1) 0.01%,
    rgba(123, 71, 236, 0.1) 100%
  );
`;

export const QRInfoText = styled.span`
  color: ${({ theme }) => theme.colors.text.black};
  font-size: 13px;
  font-weight: 500;

  .accent {
    color: ${({ theme }) => theme.colors.text.accent};
  }
`;
